import * as React from 'react';
import { useEffect, useState } from 'react';
import wrapStore from '@src/utils/wrap-store';
import styles from './index.less';
import JoinStore from './store';
import aos from '@src/utils/aos';
import cx from 'classnames';
// import SilentVideo from '@src/components/silent-video';
const JoinPage = ({ store }) => {
  store.use();
  aos.reInit();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (!isVisible) {
            setIsVisible(true);
            observer.disconnect(); // 一旦显示就停止观察
          }
        }
      },
      {
        threshold: 0.6 // 当10%的元素可见时触发
      }
    );

    const element = document.getElementById('join');
    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className={cx(styles.root, 'section', { [styles.visibleRoot]: isVisible })} id="join">
      <div className={styles.title}>如何加入我们</div>
      <div className={styles.flow}>
        <div className={styles.flowBox}>
          <div className={styles.lineA} />
          <div className={styles.lineB} />
          <div className={styles.lineC} />
          {store.arr.map((item, index) => (
            <div className={`${styles.item} item_${index}`} key={item.id}>
              <div className={`${styles.itemIcon} itemIcon_${index}`} />
              <div className={`${styles.itemTit} itemTit_${index}`}>{item.titles}</div>
              <div className={`${styles.itemSubhead} itemSubhead_${index}`}>{item.detail}</div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.left}>
        <div className={styles.cooperate}>
          <div className={styles.titleCont}>
            <div className={`${styles.titleIcon} titleIcon_a`} />
            <div className={styles.titleTex}>{store.contact_title}</div>
          </div>
          <div className={styles.leftEmail}>{store.contact_email}</div>
        </div>
        <div className={styles.report}>
          <div className={styles.titleCont}>
            <div className={`${styles.titleIcon} titleIcon_b`} />
            <div className={styles.titleTex}>{store.contact_title2}</div>
          </div>
          <div className={styles.leftEmail}>{store.contact_email2}</div>
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.wxCony}>
          <div className={styles.titleCont}>
            <div className={`${styles.titleIcon} titleIcon_c`} />
            <div className={styles.titleTex}>{store.msg1}</div>
          </div>
          <div className={styles.wxMsg}>{store.msg2}</div>
        </div>
        <div className={styles.qrCont}>
          <div className={styles.iconCont}>
            <div className={styles.rigIcon_a} />
            <div className={styles.rigIcon_b} />
            <div className={styles.rigIcon_c} />
          </div>
          <div className={styles.qrCode}>
            <img src={store.qrCode} />
          </div>
        </div>
      </div>
      <div className={styles.leftB} />
    </div>
  );
};

export default wrapStore(JoinPage, JoinStore);
